<div class="grid" id="about">
    <div class="col-12 col-md-12 col-lg-12 col-sm-12">
        <!-- <div class="section-header">
            <h3 style="display: inline-block;" name="about"><b>About This {{resourceType}}</b></h3>
        </div> -->

        <div class="section-header">
            <div style="width: 100%; height: 27px; margin-bottom: 1em;" id="aboutHeader" #aboutHeader (window:resize)="onResize()"></div>
        </div>
        <div class="section-line"></div>

        <aboutdataset-detail [record]="record" [inBrowser]="inBrowser" [mobileMode]="mobileMode" [metricsData]="metricsData" [showJsonViewer]='showJsonViewer' [theme]="theme">
        </aboutdataset-detail>
    </div>
</div>
